import { render, staticRenderFns } from "./AccountingJournalPage.vue?vue&type=template&id=6d254712&scoped=true"
import script from "./AccountingJournalPage.vue?vue&type=script&lang=js"
export * from "./AccountingJournalPage.vue?vue&type=script&lang=js"
import style0 from "./AccountingJournalPage.vue?vue&type=style&index=0&id=6d254712&prod&scoped=true&lang=css"
import style1 from "./AccountingJournalPage.vue?vue&type=style&index=1&id=6d254712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d254712",
  null
  
)

export default component.exports